import { Toast } from "antd-mobile";


//弹框
export default function BpmToast(content) {
  Toast.show({
    content,
    position: 'bottom',
  })
}